require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-pimss-asset-management-system.json") })
        }
      }, "path---study-pimss-asset-management-system");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-pimss-asset-management-system!./.cache/json/study-pimss-asset-management-system.json
// module id = 930
// module chunks = 231608221292675